module.exports = Object.assign({
  breakfast_included: 'breakfast_included',
  non_refundable: 'non_refundable',
  cancellation_text: 'cancellation_text',
  cancellation_date: 'cancellation_date'
});
